import { errorsCatalog } from "./json/errors_catalog";
import { materialBaseLimits } from "./json/material_base_limits";
import { partPriority as partPriorityJson } from "./json/part_priority";
const definePartPriority = (value) => value;
export const partPriority = definePartPriority(partPriorityJson);
export { errorsCatalog };
export { materialBaseLimits };
export const computeTubeVolume = (outerDiameterMm, innerDiameterMm, lengthMm) => {
    const outerR = outerDiameterMm / 2;
    const innerR = innerDiameterMm / 2;
    return Math.PI * (outerR ** 2 - innerR ** 2) * lengthMm;
};
export const mergeJson = (a, b) => {
    const isPlainObject = (value) => typeof value === "object" && value !== null && !Array.isArray(value);
    if (isPlainObject(a) && isPlainObject(b)) {
        return { ...a, ...b };
    }
    return [a, b];
};
